import React, { useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { useToasts } from 'react-toast-notifications'
import { useUser } from '../../context/user'
import { ReactComponent as LeftArrow } from '../../svg/normalSvgs/LeftArrow.svg'
import { contactExpert } from '../../server/server'
import TextareaAutosize from 'react-autosize-textarea'
import i18n from '../../i18n'
import { useTranslation } from 'react-i18next'
import TaskMascot from '../../svg/UpstriveTaskMaskot'
import '../../styles/OtherStudentIssueSolutions.css'
import { useHistory } from 'react-router-dom'
import { Oval } from 'react-loader-spinner'

export default function ContactCoachSolution() {
    const history = useHistory()
    const { t } = useTranslation()
    const { id } = useParams()
    const [topic, setTopic] = useState('')
    const [message, setMessage] = useState('')
    const [sending, setSending] = useState(false)
    const { user } = useUser()
    const [topicError, setTopicError] = useState('')
    const [messageError, setMessageError] = useState('')

    const { addToast } = useToasts()
    const contactCounselor = async () => {
        let hasError = false

        setTopicError('')
        setMessageError('')

        if (!topic.trim()) {
            setTopicError(t('required'))
            hasError = true
        }

        if (!message.trim()) {
            setMessageError(t('required'))
            hasError = true
        }

        if (hasError) return

        setSending(true)

        const data = {
            user,
            topic,
            message,
        }

        const resp = await contactExpert(data)

        if (resp.status === 200) {
            addToast(t('Your message is sent! Someone will contact you soon'), {
                appearance: 'success',
                autoDismiss: true,
            })

            setTopic('')
            setMessage('')

            history?.push(`/solutions/${id}`)
        } else {
            console.log('contact counsellor error ', resp.data)
        }

        setSending(false)
    }

    return (
        <div className={`other-student-solutions-container ${i18n.language == 'ar' ? 'ar-lang' : ''}`}>
            <div className="other-student-solutions-title mb-15 shadow-custom-soft">
                {/* <TaskMascot className="task-mascot-other-student-solutions" /> */}
                <span className="issue-group-section-arrow">
                    <Link to={`/solutions/${id}`}>
                        <LeftArrow className={`${i18n.language == 'ar' ? 'ar-transform' : ''}`} />
                    </Link>
                </span>
                <span className="solutions-title-text">{t('connectWithTheConselor')}</span>
            </div>
            {/* <div className="contact-message-scroll"> */}
            <div className="contact-message-container shadow-custom-soft">
                <p className="contact-topic-label">{t('topic')}</p>
                <div className="contact-topic-input">
                    <input
                        type="text"
                        value={topic}
                        placeholder={t('Add a short title for your message')}
                        onChange={(e) => {
                            setTopic(e.target.value)
                            if (topicError) setTopicError('')
                        }}
                        style={i18n.language == 'ar' ? { paddingRight: 15 } : {}}
                    />
                </div>
                {topicError && <span className="input-error-text">{topicError}</span>}
                <p className="contact-topic-label">{t('message')} </p>
                <div>
                    <div className="contact-message-input">
                        <TextareaAutosize
                            value={message}
                            placeholder={t('Type your message here')}
                            rows={5}
                            onChange={(e) => {
                                setMessage(e.target.value)
                                if (messageError) setMessageError('')
                            }}
                        />
                    </div>
                    {messageError && <span className="input-error-text">{messageError}</span>}
                </div>
                <button
                    className="contact-coach-send-button mt-5"
                    onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        contactCounselor()
                    }}
                    disabled={sending}
                >
                    {sending ? <Oval secondaryColor={'#7ec5c6'} color={'#7ec5c6'} height={20} width={20} /> : <p className="contact-coach-send-text">{t('send')}</p>}
                </button>
            </div>
            {/* </div> */}
        </div>
    )
}
